// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.REG};
  .reward-points-style {
    font-weight: 800;
    color: ${(props) => props.theme.colors.TEXT.ORANGE};
  }
  .my-place-rewards .text-style-1 {
    color: ${(props) => props.theme.colors.TEXT.ORANGE};
    text-transform: uppercase;
  }
  .my-place-rewards .text-style-2 {
    color: ${(props) => props.theme.colors.TEXT.LIGHTBLUE};
    text-transform: uppercase;
  }
  .my-place-rewards .text-style-3 {
    color: ${(props) => props.theme.colors.TEXT.DARKPINK};
    text-transform: uppercase;
  }

  .different-email-link {
    color: ${(props) => props.theme.colorPalette.blue[200]};
    font-weight: bold;
  }

  .create-account-banner {
    border-left: solid 3px ${(props) => props.theme.colors.REWARDS.PLCC};
    border-top: solid 3px ${(props) => props.theme.colors.REWARDS.PLCC};
    border-right: solid 3px ${(props) => props.theme.colors.REWARDS.NON_PLCC};
    border-bottom: solid 3px ${(props) => props.theme.colors.REWARDS.NON_PLCC};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    border-radius: 6px;
  }
  .create-account-banner ul {
    margin: 10px 15px;
  }
  .create-account-banner li {
    list-style-type: disc;
    list-style-position: outside;
    margin-left: 2%;
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    }
  }
  .button-radious {
    border-radius: 6px;
  }

  .login_earn_points,
  .login-reward-points {
    display: inline-block;
  }
  .line-break {
    display: block;
    text-align: center;
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    .create-account {
      display: block;
    }
    .line-break {
      display: initial;
    }
  }
`;

export default styles;
